export default "__VITE_ASSET__DJgizLDg__"